export default __webpack_public_path__ + "static/media/google.220b238e.svg";